<ng-template #contentHeaderTemplate>
  <div class="row">
    <div class="col-12 d-flex justify-content-end">
      <button class="btn btn-primary" (click)="save()">
        {{ (user?.id ? 'misc.save_btn' : 'misc.create_btn') | translate }}
      </button>
    </div>
  </div>
</ng-template>

<form [formGroup]="form" (submit)="save()">
  <div class="col-12 col-md-9 order-md-1">
    <div class="card mb-3">
      <div class="card-header">{{ 'authenticated.administration.users.edit.details_card_header' | translate }}</div>
      <div class="card-body">
        <div class="row">

          <div class="col-12 col-lg-6 py-1">
            <app-read-only-static
              [value]="user?.name ?? ''"
              [label]="'authenticated.administration.users.edit.form.name.label' | translate"
            ></app-read-only-static>
          </div>

          <div class="col-12 col-lg-6 py-1">
            <app-read-only-static
              [value]="user?.email ?? ''"
              [label]="'authenticated.administration.users.edit.form.email.label' | translate"
            ></app-read-only-static>
          </div>

          <div class="col-12 col-lg-6 py-1">
            <app-form-group
              type="color"
              [label]="'authenticated.administration.users.edit.form.color.label' | translate"
              [formControl]="form.controls.color"
              [errorMessages]="{required: ('authenticated.administration.users.edit.form.color.validation_messages.required' | translate)}"
            ></app-form-group>
          </div>

          <div class="col-12 col-lg-6 py-1">
            <app-multi-select-enum
              [enum]="RoleEnum"
              translateKey="roleEnum"
              [multi]="true"
              [label]="'authenticated.administration.users.edit.form.roles.label' | translate"
              [formControl]="form.controls.roles"
              [errorMessages]="{required: ('authenticated.administration.users.edit.form.roles.validation_messages.required' | translate)}"
            ></app-multi-select-enum>
          </div>

        </div>
      </div>
    </div>
  </div>
</form>
